import { type FormikValues, useFormikContext } from "formik";
import lodashGet from "lodash/get";
import { type ComponentPropsWithoutRef } from "react";
import PillarFormInputWrapper, {
  type PillarFormInputWrapperProps,
} from "shared/components/pillar-form/components/PillarFormInputWrapper";

export type PillarFormUSDInputProps = PillarFormInputWrapperProps &
  Omit<ComponentPropsWithoutRef<"input">, "id" | "name" | "value" | "type">;

const PillarFormUSDInput = ({
  name,
  label,
  labelClassName,
  additionalClasses,
  className,
  onChange,
  ...props
}: PillarFormUSDInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const value = lodashGet(values, name) ?? "";
  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      label={label}
      additionalClasses={additionalClasses}
    >
      <div className="relative flex items-center">
        <div className="text-subtle absolute left-1">$</div>
        <input
          type="number"
          value={value === "" ? "" : Number(value)}
          name={name}
          id={name}
          data-testid={props.testid}
          onChange={(e) => {
            setFieldValue(
              name,
              e.target.value === "" ? "" : Number(e.target.value),
            );
            if (onChange) {
              onChange(e);
            }
          }}
          className={`appearance-textfield w-full !pl-2.5 ${className ?? ""}`}
          {...props}
        />
        <div className="text-subtle absolute right-5">USD</div>
      </div>
    </PillarFormInputWrapper>
  );
};

export default PillarFormUSDInput;
